import React from "react";
import { PAPERWORK_STATE } from "store/PaperWork/constants";
import { useSelector } from "react-redux";
import { selectPaperworkMetadata } from "store/PaperWork/selectors";
import get from "lodash/get";
import Share from "./components/Share";
import Commons from "./components/Commons";

const Actions = () => {
  const metadata = useSelector(selectPaperworkMetadata);
  const state = get(metadata, "state", null);
  const isFinished = state === PAPERWORK_STATE.APPROVED || state === PAPERWORK_STATE.REJECTED;

  if (isFinished) return <Share />;
  return <Commons />;
};

export default Actions;
